import { useSiteDashboard } from '@/hooks/useSiteDashboard';
import { KpiCard } from '@evi/ui';
import type { OperatorDashboardData } from '@evi/shared';
import { formatCurrency, formatPctDelta } from './_lib';

/** Today's revenue as the API reports it: per currency when more than one billed today (Warren, 29 Oct 2026:
 *  never USD and CAD summed at par), else the single figure. */
export function revenueTodayText(summary: OperatorDashboardData): string {
  const lines = summary.revenueTodayByCurrency ?? [];
  if (lines.length > 1) return lines.map((l) => formatCurrency(l.total_cents / 100, l.currency)).join(' + ');
  if (lines.length === 1) return formatCurrency(lines[0]!.total_cents / 100, lines[0]!.currency);
  return formatCurrency(summary.revenueToday.value);
}

export default function KpiRevenue({ summary }: { summary: OperatorDashboardData | undefined }) {
  const isSite = useSiteDashboard();
  return (
    <KpiCard
      fit
      label={isSite ? 'Charging sales today' : 'Revenue today'}
      value={summary ? revenueTodayText(summary) : '-'}
      delta={summary ? formatPctDelta(summary.revenueToday.deltaPct) : undefined}
    />
  );
}
